import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ElementRef,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'cs-timer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="cs-timer" #container>
      <div 
        class="cs-timer__bar"
        [ngStyle]="{
          'width': (100 - inputs.timePercentage) + '%'
        }">
      </div>

      <div 
        class="cs-timer__time-left"
        [ngStyle]="{
          'right': getLabelRightPercentage() + '%'
        }">
        <span class="cs-label">
          {{ inputs.label }}
        </span>
        <span class="cs-value">
          {{ inputs.timeLeft }}
        </span>
      </div>
    </div>
  `
})

export class CsTimerComponent {
  @Input() inputs: any;
  @ViewChild('container') container: ElementRef;

  constructor() { }

  getLabelRightPercentage() {
    let containerWidth, limitPercentage;

    if (this.container &&
      this.container.nativeElement &&
      this.inputs.timePercentage) {
      containerWidth = this.container.nativeElement.clientWidth;
      limitPercentage = 100 - ((150 * 100) / containerWidth);

      return Math.min(
        this.inputs.timePercentage + 1,
        limitPercentage
      );
    }

    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-timer/cs-timer.component.ts